import React from "react"
import MaskQF from "../../../images/quick-fin-reduzido.svg"
import SacadoPlatform from "../../../images/sacado-plataforma.png"
import styled from "styled-components"
import {
  SectionWrapper,
  SectionImageBox,
  SectionTitleMobile,
  SectionImage,
  SectionDivisor,
  SectionTitleDesktop,
  DetailList,
  DetailListItem,
} from "../landing-section.styles"

export const SectionWhiteBg = styled.section`
  background-color: #fff;
  background-image: url(${MaskQF});
  background-repeat: no-repeat;
  background-position: -320px 20px;
  background-size: contain;
`

export default function SectionFornecedor() {
  return (
    <SectionWhiteBg>
      <SectionWrapper>
        <div>
          <SectionImageBox>
            <SectionTitleMobile>
              Simples e objetivo <br />
              para o <b>Fornecedor</b>
            </SectionTitleMobile>
            <SectionImage src={SacadoPlatform} data-zoomable />
          </SectionImageBox>
        </div>
        <SectionDivisor>
          <SectionTitleDesktop>
            Simples e objetivo <br />
            para o <b>Fornecedor</b>
          </SectionTitleDesktop>
          <DetailList>
            <DetailListItem>
              Antecipar seus recebíveis com o Quickfin é rápido, fácil e sem
              burocracias.
            </DetailListItem>
            <DetailListItem>
              Seu dinheiro em caixa em até 1 dia útil com a taxa menor que
              qualquer empréstimo.
            </DetailListItem>
          </DetailList>
        </SectionDivisor>
      </SectionWrapper>
    </SectionWhiteBg>
  )
}
